import React from 'react';
import PropTypes from 'prop-types';
import { SplitButton } from 'react-bootstrap/lib';
import DeleteButton from './DeleteButton';

function EditButton({ feedview, editFeedview, onDelete }) {
  return (
    <SplitButton
      title="Edit"
      key={feedview.id}
      id={`split-button-basic-group-${feedview.id}`}
      onClick={() => {
        editFeedview(feedview.id);
      }}
    >
      <DeleteButton feedview={feedview} onDelete={onDelete} />
    </SplitButton>
  );
}

EditButton.propTypes = {
  feedview: PropTypes.object,
  editFeedview: PropTypes.func,
  onDelete: PropTypes.func,
};

export default EditButton;
